<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasEmployee="true"
      :hasTerminal="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
      :reportTypes="reportTypes"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      reportTypes: ["simple", "detail"],
      reportType: "simple",
    };
  },
  computed: {
    columns() {
      if (this.reportType == "simple") {
        return [
          { name: "EmployeeNumber" },
          { name: "EmployeeName" },
          { name: "WorkTime" },
          { name: "WorkTimeHour" },
          { name: "WorkTimeMinute" },
        ];
      } else {
        return [
          { name: "EmployeeNumber" },
          { name: "EmployeeName" },
          { name: "ToWork" },
          { name: "OffWork" },
          { name: "WorkTime" },
          { name: "WorkTimeHour" },
          { name: "WorkTimeMinute" },
          { name: "TerminalNumber" },
          { name: "TerminalName" },
          { name: "IsToWorkRepairText" },
          { name: "IsOffWorkRepairText" },
        ];
      }
    },
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getWorkRecord(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getWorkRecord(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printWorkRecord(condition);
    },
    getItems(condition) {
      this.reportType = condition.ReportType;

      const vm = this;
      this.$api.reports.getWorkRecord(condition).then((data) => {
        vm.items = data.Datas;
        vm.items.forEach((item) => {
          if (item.IsToWorkRepair == 1) {
            item.IsToWorkRepairText = "V";
          } else if (item.IsToWorkRepair == 0) {
            item.IsToWorkRepairText = "";
          }
          if (item.IsOffWorkRepair == 1) {
            item.IsOffWorkRepairText = "V";
          } else if (item.IsOffWorkRepair == 0) {
            item.IsOffWorkRepairText = "";
          }
        });
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
